import { render, staticRenderFns } from "./permission_admin.vue?vue&type=template&id=6e884c60&"
import script from "./permission_admin.vue?vue&type=script&lang=js&"
export * from "./permission_admin.vue?vue&type=script&lang=js&"
import style0 from "./permission_admin.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports